export default __webpack_public_path__ + "static/media/cnbc_jpmorgan.f70a7f62.jpg";